export enum StopType {
  START = 'start',
  END = 'end',
  INFLEXION = 'inflexion',
  DEMAND = 'demand',
  MERGE = 'merge',
  ALTERNATIVES = 'alternatives',
  ALTERNATIVE_OF = 'alternativeOf'
}